<script>
import OrdersTable from './OrdersTable.vue'
export default {
  components: { OrdersTable },
  props: {
    status: { type: String },
    orders: { type: Array },
    fetchOrders: { type: Function },
    totalOrders: { type: Number }
  },
  data: () => ({
    isErrorDialogOpen: false,
    errorDialogContent: '',
    snackbar: false,
    snackbarTimeout: 3000,
    isDeleting: false
  }),
  methods: {
    deleteOrderWrapper: function(id) {
      this.isDeleting = true
      this.$ordersService
        .deleteOrder(id)
        .then(() => {
          this.fetchOrders()
          this.snackbar = true
        })
        .catch(() => {
          this.errorDialogContent = this.$t('component.orders.ordersList.error.dialog.content.delete.order')
          this.isErrorDialogOpen = true
        })
        .finally(() => {
          this.isDeleting = false
        })
    },
    downloadInvoice: function(id, orderNumber) {
      this.$ordersService
        .getInvoice(id)
        .then(response => {
          let a = document.createElement('a')
          a.href = 'data:application/pdf;base64,' + response
          a.download = this.$t('component.orders.ordersList.billing.pdf.naming') + orderNumber + '.pdf'
          a.click()
        })
        .catch(() => {
          this.errorDialogContent = this.$t('component.orders.ordersList.error.dialog.content.download.invoice')
          this.isErrorDialogOpen = true
        })
    }
  }
}
</script>
<template>
  <div>
    <v-overlay :value="isDeleting">
      <v-card light>
        <v-card-text class="text-center">
          <v-progress-linear indeterminate color="red"></v-progress-linear>
          <span>{{ $t('component.orders.ordersList.overlay.deleting.order') }}</span>
        </v-card-text>
      </v-card>
    </v-overlay>
    <v-snackbar
      v-model="snackbar"
      top
      color="success"
      :timeout="snackbarTimeout">
      {{ $t('component.orders.ordersList.snackbar.success.content') }}
      <v-btn dark icon @click="snackbar = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-dialog v-model="isErrorDialogOpen" :max-width="500">
      <v-card>
        <DialogBaseColoredTitle color="error">{{
            $t('component.orders.ordersList.error.dialog.header')}}</DialogBaseColoredTitle>
        <v-divider></v-divider>
        <DialogBaseText class="text-center primary--text">
          <v-row>
            <v-col>{{ errorDialogContent }}</v-col>
          </v-row>
          <v-divider></v-divider>
        </DialogBaseText>
        <DialogBaseActions>
          <v-btn
            class="text-center px-8"
            color="primary"
            @click="isErrorDialogOpen = false">
            {{ $t('button.close') }}
          </v-btn>
        </DialogBaseActions>
      </v-card>
    </v-dialog>
    <OrdersTable
      v-if="orders.length > 0"
      :orders="orders"
      :delete-order="deleteOrderWrapper"
      :download-invoice="downloadInvoice"
      :fetch-orders="fetchOrders"
      @refetch-orders="fetchOrders"
      @update:updated="$emit('update:updated', $event)"
    />
  </div>
</template>
<style lang="scss" scoped>
div[name^='ordersList'] {
  overflow-y: scroll;
}
</style>
